import { calculatePercentageAmount } from "./calculatePercentageAmount";

export const getTotalForBeneFit = (
  data: any,
  black_list?: string[]
): { current_total: number; proposed_total: number } => {
  let current_total = 0;
  let proposed_total = 0;

  for (let key in data) {
    if (data[key] && !black_list?.includes(key)) {
      if (Array.isArray(data[key])) {
        // eslint-disable-next-line no-loop-func
        data[key].forEach((item: any) => {
          if (item?.is_current && item?.value) {
            current_total += item.value;
          } else if (!item?.is_current && item?.value) {
            const fixed_proposed_total = data?.fixed_proposed_total;
            const proposed_annual_base = data?.proposed_annual_base;
            // original_value comment
            if (item?.calculation_basis === "percent_guaranteed") {
              // proposed_total += calculatePercentageAmount(Number(fixed_proposed_total), Number(item?.original_value?.value));
              proposed_total += calculatePercentageAmount(
                Number(fixed_proposed_total),
                Number(item.value)
              );
            } else if (item?.calculation_basis === "percent_basic") {
              // proposed_total += calculatePercentageAmount(Number(proposed_annual_base), Number(original_value.value));
              proposed_total += calculatePercentageAmount(
                Number(proposed_annual_base),
                Number(item.value)
              );
            } else {
              proposed_total += item.value;
            }
          }
        });
      } else {
        if (key?.includes("current") && !key?.includes("_total")) {
          current_total += data[key];
        } else if (key?.includes("proposed") && !key?.includes("_total")) {
          proposed_total += data[key];
        }
      }
    }
  }

  return { current_total, proposed_total };
};
